import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { ProfileState } from '@alfresco/adf-extensions';

import { filter, take, takeUntil, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppStore } from '../../store/states/app.state';
import { Subject } from 'rxjs';
import { ContentService } from '../../components/shared/services/content.service';
import { FormModel } from '@alfresco/adf-core';

import { SiteConfigService } from '../../services/site-config.service';
import { getUserProfile } from '../../store/selectors/app.custom-selectors';
import { FileModel } from '@alfresco/adf-content-services';

@Component({
  selector: 'wk-upload-files-dropdown',
  templateUrl: './wk-upload-files-dropdown.component.html',
  styleUrls: ['./wk-upload-files-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'wk-upload-files-dropdown' },
  standalone: false,
})
export class WkUploadFilesDropdownComponent implements OnInit {
  currentSelection = null;
  @Input() documentType: any;
  @Input() allowedDocTypes: any;
  @Input() file: FileModel;
  @Input() directoryName;
  _onDestroy = new Subject<void>();
  filterType: string;
  noTemplateFormShared: boolean;
  formId: number;
  templateId: string;
  formModel: FormModel;
  templateFormName: string;
  currentSite;
  constructor(
    private readonly contentService: ContentService,
    private readonly store: Store<AppStore>,
    private readonly siteAppConfig: SiteConfigService
  ) {
    this.currentSite = localStorage.getItem('currentSite');
  }

  ngOnInit() {
    if (this.documentType) {
      const uploadTypeObject = this.siteAppConfig.getCurrentSelection(
        this.currentSite,
        this.directoryName,
        this.documentType
      );
      this.currentSelection = this.allowedDocTypes.find(
        (i) => i.title === uploadTypeObject.title
      );
      this.file.options.nodeType = uploadTypeObject.nodeType;
      this.file.options.properties.uploadedObject = uploadTypeObject;
      this.templateFormName = uploadTypeObject.uploadForm;
      this.getFormInfo();
    }
  }

  onDropDownSelection(event) {
    this.siteAppConfig.setPathIfConfigured(event, null, this.currentSite);
    this.file.options.nodeType = event.nodeType;
    this.file.options.properties.uploadedObject = event;
    this.templateFormName = event.uploadForm;
    this.getFormInfo();
  }

  getFormInfo(): void {
    if (!this.filterType) {
      this.store
        .select(getUserProfile)
        .pipe(
          take(1),
          tap(
            (profileState: ProfileState) =>
              (this.filterType = profileState.isAdmin
                ? 'myReusableForms'
                : 'sharedWithMe')
          ),
          takeUntil(this._onDestroy)
        )
        .subscribe(() => this.getFormId());
    } else {
      this.getFormId();
    }
  }

  protected getFormId(): void {
    this.contentService
      .getFormId(this.filterType, this.templateFormName)
      .pipe(
        tap((formId: string) => {
          if (formId === 'no-template-form') {
            this.noTemplateFormShared = true;
            this.resetFormInfo();
          }
        }),
        filter((formId: string) => formId !== 'no-template-form'),
        takeUntil(this._onDestroy)
      )
      .subscribe((formId: string) => (this.formId = Number(formId)));
  }

  protected resetFormInfo(): void {
    this.formId = null;
    this.templateFormName = '';
    this.templateId = '';
  }

  formLoaded(formModel: FormModel): void {
    this.formModel = formModel;
    this.file.options.properties.form = formModel;
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
